var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.7581L16.5 18.7581C17.6046 18.7581 18.5 17.8626 18.5 16.7581L18.5 2.75806C18.5 1.65349 17.6046 0.758057 16.5 0.758057L2.5 0.758057C1.39543 0.758057 0.5 1.65349 0.5 2.75806L0.5 16.7581C0.5 17.8626 1.39543 18.7581 2.5 18.7581Z",
    fill: "url(#paint0_linear_265_4865)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 17.7581C17.0523 17.7581 17.5 17.3103 17.5 16.7581L17.5 2.75806C17.5 2.20577 17.0523 1.75806 16.5 1.75806L2.5 1.75806C1.94772 1.75806 1.5 2.20577 1.5 2.75806L1.5 16.7581C1.5 17.3103 1.94772 17.7581 2.5 17.7581L16.5 17.7581ZM18.5 16.7581C18.5 17.8626 17.6046 18.7581 16.5 18.7581L2.5 18.7581C1.39543 18.7581 0.5 17.8626 0.5 16.7581L0.5 2.75806C0.5 1.65349 1.39543 0.758057 2.5 0.758057L16.5 0.758057C17.6046 0.758057 18.5 1.65349 18.5 2.75806L18.5 16.7581Z",
    fill: "#3A56A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5401 2C13.8566 4.31516 10.545 7.17494 7.71809 10.482L4.05209 7.598C3.3053 8.11638 2.61605 8.71311 1.99609 9.378L8.67209 16.194C8.69596 16.2205 8.72532 16.2415 8.75814 16.2555C8.79096 16.2695 8.82644 16.2761 8.86209 16.275C8.87904 16.277 8.89615 16.277 8.91309 16.275C8.95672 16.2657 8.99733 16.2457 9.03122 16.2167C9.06511 16.1877 9.0912 16.1507 9.10709 16.109C11.3131 11.3145 14.4236 6.99076 18.2681 3.375C18.3079 3.33739 18.3354 3.28856 18.3468 3.23497C18.3583 3.18139 18.3531 3.12559 18.3321 3.075C18.1006 2.69381 17.8356 2.33404 17.5401 2V2Z",
    fill: "url(#paint1_linear_265_4865)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13136 10.6452L7.9717 10.8263L4.00977 7.57331L4.32705 7.18688L7.91711 10.1346C7.94922 10.0989 7.98591 10.0582 8.02695 10.0129C8.20117 9.82056 8.45384 9.54449 8.76825 9.20892C9.39691 8.53792 10.2731 7.62826 11.2628 6.67405C12.252 5.72026 13.3572 4.71947 14.4437 3.86746C15.5265 3.01836 16.606 2.30479 17.5423 1.93921L17.7242 2.40496C16.8575 2.74338 15.8243 3.42029 14.7523 4.26092C13.684 5.09863 12.5922 6.08681 11.6098 7.03399C10.6279 7.98074 9.75779 8.88404 9.13312 9.55077C8.82086 9.88406 8.57009 10.158 8.39753 10.3486C8.31125 10.4438 8.24454 10.5182 8.19947 10.5686L8.14837 10.626L8.13549 10.6406L8.13136 10.6452Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_4865",
    x1: 9.5,
    y1: 18.7581,
    x2: 9.5,
    y2: 0.758057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_265_4865",
    x1: 10.1744,
    y1: 2,
    x2: 10.1744,
    y2: 16.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52781F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.f22df38f.svg";
export { ForwardRef as ReactComponent };